var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5706 0.853844C12.5506 -0.123156 14.1306 -0.123156 15.1106 0.853844L18.4906 4.23184C19.4606 5.20884 19.4606 6.79084 18.4906 7.76784L7.25061 18.9998H0.340607V12.0858L11.5706 0.853844ZM13.6906 2.26784C13.5006 2.07284 13.1806 2.07284 12.9906 2.26784L2.34061 12.9138V16.9998H6.43061L17.0706 6.35384C17.2706 6.15784 17.2706 5.84184 17.0706 5.64584L13.6906 2.26784ZM12.0906 16.9998L10.0906 18.9998H18.3406V16.9998H12.0906Z",
    fill: "#4496D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosts);
export default __webpack_public_path__ + "static/media/posts.fcf9e0c6552d818c18dfe682ed2ca786.svg";
export { ForwardRef as ReactComponent };